<template>
  <div
    :id="node.id ? node.id : false"
    class="document-node"
    :class="{ [node.layout]: node.layout }"
    ref="main"
    v-if="node.type"
  >
    <div
      v-if="node.type !== 'placeholder' && reorderActivated"
      class="reorder-btn"
      @mousedown.prevent="startMove($event, $refs.main)"
    >
      <svg viewBox="0 0 30 15">
        <polygon points="0 10, 15 0, 30 10" />
      </svg>
      Reorder
      <svg viewBox="0 0 30 15">
        <polygon points="0 0, 15 10, 30 0" />
      </svg>
    </div>

    <section v-if="node.type == 'section'" class="pigeondoc_section">
      <NodeManager
        v-for="(sectionNode, index) in modelValue.content"
        :key="sectionNode.uuid"
        :modelValue="sectionNode"
        display="view"
        :editable="editable"
        :thisCollection="thisCollection"
        :isICCS="isICCS"
        @update:modelValue="sectionUpdate(index, $event)"
        @nodeMoveStart="bubbleStartMove"
        @nodeAdded="nodeAdded"
      />
    </section>

    <!-- TODO add the correct update to this, as someone can still add headings directly themselves -->
    <component
      v-else-if="mode == 'edit'"
      :is="nodeTemplates[node.type].edit"
      :value="modelValue"
      :isICCS="isICCS"
      @change="onChange"
      @editFinish="close"
    ></component>

    <component
      v-else-if="mode == 'view'"
      :is="nodeTemplates[node.type].view"
      :isICCS="isICCS"
      :value="modelValue"
      @update-node="updateNode"
      ref="node"
    ></component>

    <template v-if="editable">
      <button
        v-if="mode == 'view' && (node.type === 'heading' || node.type === 'text')"
        @click="edit"
        class="document-node__edit"
      >
        edit
      </button>
    </template>
  </div>
</template>

<script>
import _cloneDeep from 'lodash/cloneDeep';
import PigeonDocNodeModel from '../../models/PigeonDocNodeModel';
//import PigeonDocModel from '../../models/PigeonDocModel';
import nodeTemplates from './node-templates.js';
import EditEvtBus from './EditEvtBus';

export default {
  name: 'NodeManager',
  provide() {
    return {
      editBus: this.editBus,
    };
  },

  props: {
    modelValue: PigeonDocNodeModel,
    display: {
      type: String,
      default: 'view',
    },
    editable: {
      type: Boolean,
      default: false,
    },
    thisCollection: {
      type: String,
      default: '',
    },
    isICCS: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      editBus: new EditEvtBus(),
      node: _cloneDeep(this.modelValue),
      mode: 'view',
      nodeTemplates,
      reorderActivated: false,
    };
  },
  mounted() {
    // Only emit the nodeAdded event if one is actually added, if the NodeManager is starting the render
    // of a section then one isn't directly created by this instance.
    if (this.$refs['node']) {
      this.$emit('nodeAdded', this.$refs['node']);

      this.editBus.on('update', (update) => {
        Object.keys(update).forEach((path) => {
          const keys = path.split('.');
          if (keys.length > 1) {
            let field = keys.reduce(
              (update, key) => {
                update.key = key;
                if (typeof update.level[key] === 'object') {
                  update.level = update.level[key];
                }
                return update;
              },
              { level: this.node, key: null },
            );
            field.level[field.key] = update[path];
          } else {
            this.node[path] = update[path];
          }
        });
      });
    }
  },
  watch: {
    node: {
      handler() {
        this.$emit('update:modelValue', this.node);
      },
      deep: true,
    },
  },
  methods: {
    edit() {
      this.mode = 'edit';
      const listener = (e) => {
        if (!this.$el.contains(e.target)) {
          this.close();
          window.removeEventListener('click', listener, true);
        }
      };

      window.addEventListener('click', listener, true);
    },
    close() {
      this.mode = 'view';
    },
    startMove(e, ref) {
      this.$emit('nodeMoveStart', e, ref, this.node);
    },
    bubbleStartMove(e, ref, docNode) {
      this.$emit('nodeMoveStart', e, ref, docNode);
    },
    updateNode(node) {
      this.$emit('updateNode', this.node);
      this.node = node;
    },
    nodeAdded(node) {
      this.$emit('nodeAdded', node);
    },
    onChange(node) {
      this.node = node;
    },
    sectionUpdate(index, node) {
      this.node.content[index] = node;
    },
    updateThisNode(newNode) {
      this.node = newNode;
    },
  },
};
</script>

<style lang="scss">
.reorder-btn {
  font-size: 0.8rem;
  width: 4ch;
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1;
}

.reorder-btn svg {
  width: 60%;
}

.bottom-btn {
  top: auto !important;
  bottom: 2em;
}
</style>
